import { ItemSeverityLevel } from "../Item"
import { Notification } from "./Notification"

export class NotificationBugWatermark extends Notification {
  level: ItemSeverityLevel

  constructor(props) {
    super(props)

    this.level = props.level
  }
}
